/*  MUI  */
import { Typography } from '@mui/material';

/*  React  */
import React from 'react';

export const SentenceCase = ({ text, styleProps }) => (
    <Typography
        data-testid="sentenceCase"
        sx={{
            '&:first-letter': {
                textTransform: 'uppercase'
            },
            textTransform: 'lowercase',
            ...styleProps
        }}
    >
        {text}
    </Typography>
);
